// extracted by mini-css-extract-plugin
export var background = "NumberInput-module__background";
export var disabled = "NumberInput-module__disabled";
export var focus = "NumberInput-module__focus";
export var numberInput = "NumberInput-module__number-input";
export var rangeInput = "NumberInput-module__range-input";
export var rangeNumberInput = "NumberInput-module__range-number-input";
export var rangeWrapper = "NumberInput-module__range-wrapper";